<template>
  <div class="mask">
    <div :class="ticketClasses">
      <Separator />
      <p>Jij bestelt gemiddeld<br>
      <b>{{ amount }} pakjes per maand</b><br>
      Dat levert</p>
      <Grams>{{ grams }}gr</Grams>
      <p>CO2 op</p>
      <p>Dat is vergelijkbaar met<br>{{ compareText }}</p>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import Separator from './Separator'
import Grams from './Grams'
import { trackCalculate } from '@/utils/track'

export default {
  name: 'Ticket',
  data () {
    return {
      amount: 1
    }
  },
  mounted () {
    EventBus.$on('packages-sent-change', val => {
      this.amount = val
    })
  },
  components: {
    Separator,
    Grams
  },
  props: {
    print: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    print () {
      trackCalculate(this.grams)
    }
  },
  computed: {
    grams () {
      return this.amount * 418
    },
    ticketClasses () {
      return {
        'ticket': true,
        'out': this.print
      }
    },
    compareText () {
      const km = this.amount * 2
      return `${km} kilometer autorijden`
    }
  }
}
</script>

<style lang="scss" scoped>
.mask {
  z-index: 3;
  position: absolute;
  width: 261px;
  top: 209px;
  left: 0;
  right: 0;
  margin: 0 auto;
  overflow: hidden;
}

.ticket {
  background-color: white;
  border-radius: 0 0 10px 10px;
  color: $c-dark;
  width: 100%;
  padding: 12px 20px 20px;
  text-align: center;
  transform: translateY(-100%);
  transition: transform 1s cubic-bezier(.19,1,.22,1) 1.4s;
  will-change: transform;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
    height: 0;
    border-bottom: 36px solid transparent;
    border-left: 0px solid transparent;
    border-right: 261px solid #EBEBE6;
  }
}

.out {
  transform: translateY(0%);
}
</style>
